<template>
  <v-container>
    <v-row>
      <v-col cols="12" class="font-weight-black title">
        <h1>DASHBOARD</h1>
        <br />
        <span class="red--text">W A R N I N G !</span>
        <p style="font-size:1rem">Any change here is irreversible!</p>
      </v-col>
      <v-col cols="12">
        <h2 style="text-align:start">Manage Content:</h2>
      </v-col>
      <v-col cols="6" sm="4" md="3" v-for="item in sorted" :key="item.title">
        <v-btn width="100%" color="white" elevation="1" :to="item.path">{{item.title}}</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "EditDashboard",
  data() {
    return {
      buttons: [
        { title: "Team Members", path: "/edit/members" },
        { title: "Group photos", path: "/edit/group-photos" },
        { title: "Cover gallery", path: "/edit/cover-gallery" },
        { title: "News", path: "/edit/news" },
        { title: "Media", path: "/edit/media" },
        { title: "Publications", path: "/edit/publications" },
        { title: "Beyond research", path: "/edit/beyond" },
        { title: "Sponsors", path: "/edit/sponsors" },
        { title: "Open Source", path: "/edit/opensource" }
      ]
    };
  },
  computed: {
    sorted() {
      const y = this.buttons;
      return y.sort((a, b) => {
        if (a.title < b.title) return -1;
        if (a.title === b.title) return 0;
        return 1;
      });
    }
  }
};
</script>